import Marquee from "react-fast-marquee";
import { useEffect, useState } from "react";
import { AlertTriangle, CalendarClock } from "lucide-react";
import { api } from "@/lib/api";

const ScrollingBanner = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    let cancelled = false;
    api.get("/banner")
      .then((res) => {
        if (!cancelled) setItems(res.data.filter((i) => i.active));
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  if (!items.length) return null;

  return (
    <div
      className="bg-primary text-primary-foreground border-b border-white/10"
      data-testid="scrolling-banner"
      role="region"
      aria-label="Township announcements"
    >
      <Marquee pauseOnHover gradient={false} speed={42} className="py-2.5">
        {items.map((it) => (
          <span key={it.id} className="inline-flex items-center gap-2 mx-8 text-sm font-medium tracking-wide" data-testid={`banner-item-${it.id}`}>
            {it.kind === "meeting" ? (
              <CalendarClock size={16} className="text-accent" aria-hidden="true" />
            ) : (
              <AlertTriangle size={16} className="text-accent" aria-hidden="true" />
            )}
            {it.text}
            <span className="text-primary-foreground/40 mx-3" aria-hidden="true">•</span>
          </span>
        ))}
      </Marquee>
      {/* WCAG 2.2.2 — provide a non-animated alternative for screen-reader users */}
      <ul className="sr-only" aria-label="Township announcements (full list)">
        {items.map((it) => (
          <li key={`sr-${it.id}`}>{it.text}</li>
        ))}
      </ul>
    </div>
  );
};

export default ScrollingBanner;
